import { SxProps, Theme } from '@mui/material'

/**
 * Shared prose styling applied identically to the editable editor and the
 * read-only renderer so published pages look exactly as authored.
 */
export const proseSx: SxProps<Theme> = {
  '& .ProseMirror': {
    outline: 'none',
    minHeight: '200px',
    fontSize: '15px',
    lineHeight: 1.7,
    color: 'text.primary',
    wordBreak: 'break-word',
  },
  '& .ProseMirror:focus': { outline: 'none' },
  '& .ProseMirror p': { margin: '0 0 12px' },
  '& .ProseMirror h1': { fontSize: '28px', fontWeight: 700, margin: '20px 0 12px' },
  '& .ProseMirror h2': { fontSize: '22px', fontWeight: 700, margin: '18px 0 10px' },
  '& .ProseMirror h3': { fontSize: '18px', fontWeight: 600, margin: '16px 0 8px' },
  '& .ProseMirror ul, & .ProseMirror ol': { paddingLeft: '24px', margin: '0 0 12px' },
  '& .ProseMirror li': { margin: '4px 0' },
  '& .ProseMirror blockquote': {
    borderLeft: '3px solid',
    borderColor: 'divider',
    paddingLeft: '16px',
    color: 'text.secondary',
    margin: '0 0 12px',
  },
  '& .ProseMirror a': { color: 'primary.main', textDecoration: 'underline' },
  '& .ProseMirror img': { maxWidth: '100%', borderRadius: '8px', display: 'block', margin: '12px 0' },
  '& .ProseMirror code': {
    backgroundColor: 'action.hover',
    borderRadius: '4px',
    padding: '2px 4px',
    fontSize: '13px',
  },
  '& .ProseMirror pre': {
    backgroundColor: 'action.hover',
    borderRadius: '8px',
    padding: '12px',
    overflowX: 'auto',
    margin: '0 0 12px',
  },
  // Placeholder (only shown in the editable editor when empty)
  '& .ProseMirror p.is-editor-empty:first-of-type::before': {
    content: 'attr(data-placeholder)',
    float: 'left',
    color: 'text.disabled',
    pointerEvents: 'none',
    height: 0,
  },
}
